// extracted by mini-css-extract-plugin
export default {"notifications":"Notifications_notifications__M8z9a","backdrop":"Notifications_backdrop__WuAE5","field":"Notifications_field__hR9RM","label":"Notifications_label__m6RHK"};